import { useState } from "react";
import { createContext, useContext } from "react";
const UserContext = createContext();

export const useIatfContext = () => {
  return useContext(UserContext);
};

export const IatfProvider = ({ children }) => {
  const [loginDetails, setLoginDetails] = useState([]);

  // Add any other state or functions you want to share

  return (
    <UserContext.Provider value={{ loginDetails, setLoginDetails }}>
      {children}
    </UserContext.Provider>
  );
};
